<app-generic-popup
  [visible]="localVisible()"
  (visibleChange)="localVisible.set($event)"
  [title]="title ?? popupTitle"
  [width]="'478px'"
  [leftButtons]="[]"
  [buttons]="confirmButtons"
  (onHiding)="onHidingHandler()"
  [content]="message"
></app-generic-popup>
